import * as React from 'react'

import { cn } from './cn'

export interface RatingProps {
  value?: number | null
  max?: number
  readOnly?: boolean
  precision?: number
  size?: 'small' | 'medium' | 'large'
  onChange?: (event: React.SyntheticEvent, value: number | null) => void
  className?: string
}

const sizeClasses = {
  small: 'h-[18px] w-[18px]',
  medium: 'h-6 w-6',
  large: 'h-[30px] w-[30px]',
}

const Star = ({ fill, className }: { fill: number; className?: string }) => (
  <span className={cn('relative inline-block', className)}>
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className="h-full w-full text-black/25 dark:text-white/30"
    >
      <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
    </svg>
    {fill > 0 && (
      <span
        className="absolute inset-0 overflow-hidden"
        style={{ width: `${fill * 100}%` }}
      >
        <svg
          viewBox="0 0 24 24"
          fill="currentColor"
          className="h-full w-full text-[#faaf00]"
          style={{ width: `${100 / fill}%` }}
        >
          <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
        </svg>
      </span>
    )}
  </span>
)

const Rating = ({
  value = 0,
  max = 5,
  readOnly,
  size = 'medium',
  onChange,
  className,
}: RatingProps) => (
  <span
    role="img"
    aria-label={`${value ?? 0} of ${max} stars`}
    className={cn('inline-flex items-center', className)}
  >
    {Array.from({ length: max }, (_, i) => {
      const fill = Math.min(1, Math.max(0, (value ?? 0) - i))
      const star = <Star key={i} fill={fill} className={sizeClasses[size]} />
      if (readOnly || !onChange) return star
      return (
        <button
          key={i}
          type="button"
          className="cursor-pointer"
          aria-label={`${i + 1} stars`}
          onClick={(e) => onChange(e, i + 1)}
        >
          {star}
        </button>
      )
    })}
  </span>
)

export default Rating
